"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateToNextWeek = void 0;
const startOfWeek_1 = __importDefault(require("date-fns/startOfWeek"));
const addWeeks_1 = __importDefault(require("date-fns/addWeeks"));
const standardDateFormat_1 = require("./standardDateFormat");
const format_1 = __importDefault(require("date-fns/format"));
exports.dateToNextWeek = (date, validStartOfWeek) => {
    const leftDt = startOfWeek_1.default(date.toDate(), {
        weekStartsOn: validStartOfWeek
    });
    return {
        startDate: format_1.default(leftDt, standardDateFormat_1.dateFnsStandardDateFormat),
        endDate: format_1.default(addWeeks_1.default(leftDt, 1), standardDateFormat_1.dateFnsStandardDateFormat)
    };
};
//# sourceMappingURL=dateToNextWeek.js.map